import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import { unzipSync } from 'zlib';
import { connected } from 'process';
import format from 'date-fns/format'
import { getUserAll, getTeamByCompany } from './core/cacheService'
import { PROGRAM_ONLY_KEY } from './huddle-helpers'
import { apiNodeRequest } from './core/main'

// A Spark set is "Program only" when its audience array carries the
// synthetic program_only cohort — parked off the public schedule and
// surfaced only when a Learning Program references it.
const isProgramOnlySet = (permissions: any) =>
    Array.isArray(permissions) && permissions.indexOf(PROGRAM_ONLY_KEY) !== -1

const normalizePermissions = (permissions: any) => {
    if (Array.isArray(permissions)) {
        const permissionKeys = permissions
            .map((permission: any) => typeof permission === 'object' ? permission.key : permission)
            .filter((permission: any) => !!permission)
        return permissionKeys.length ? permissionKeys : ["Everyone"]
    }
    return permissions ? [permissions] : ["Everyone"]
}

export default {
    namespaced: true,
    state: {
        sparkHappily:[],
        sparkHappilyloading: false,
        sparkCustom:[],
        sparkStatus:false,
        cardId:'',
        customClass:[],
        sparkType:[],
        dataSparkTypeName:{},
        loading:false,
        permissionsList:[]
    },
    mutations: {
        setSparkHappily(state: any, result: any) {
            state.sparkHappily = result
        },
        setSparkHappilyloading(state: any, result: any) {
            state.sparkHappilyloading = result
        },
        setSparkCustom(state: any, result: any) {
            state.sparkCustom = result
        },
        setSparkStatus(state: any, result: any) {
            state.sparkStatus = result
        },
        setCardId(state: any, result: any) {
            state.cardId = result
        },
        setCustomClass(state: any, result: any) {
            state.customClass = result
        },
        setSparkType(state: any, result: any) {
            state.sparkType = result
        },
        setSparkTypeName(state: any, result: any) {
            state.dataSparkTypeName = result
        },
        setLoading(state: any, result: any) {
            state.loading = result
        },
        setPermissionsList(state: any, result: any) {
            state.permissionsList = result
        },
    },
    actions: {
        async getPermissions({ commit, state,rootState }: any) {
            const permissionsList:Array<any> = [];
            permissionsList.push({key:'Everyone',label:'Everyone',value:'Everyone'})
            permissionsList.push({key:PROGRAM_ONLY_KEY,label:'Program only',value:PROGRAM_ONLY_KEY})
            // BFF team map instead of a whole-node RTDB query (also makes the list
            // ordering deterministic — the old callback raced the commit below).
            const teams = await getTeamByCompany(rootState.authen.user.company)//firebase.database().ref('team').orderByChild('company').equalTo(rootState.authen.user.company).once('value')
            for(const teamKey in teams){
                const data = teams[teamKey];
                permissionsList.push({...data,key:'team_'+teamKey,label:data.name})
            }
            firebase.database().ref('cohorts/'+rootState.authen.user.company).once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    const data = childSnapshot.val();
                    permissionsList.push({...data,key:'cohort_'+childSnapshot.key,label:data.name})
                })
            })
            const users=await getUserAll(rootState.authen.user.company)
            for(const user in users){
                permissionsList.push({...users[user],key:'user_'+user,label:users[user].firstname+' '+users[user].lastname})
            }

            commit('setPermissionsList', permissionsList)

        },
        async checkSetName({ commit, state }: any,{name,user}:any) {
            commit('setSparkStatus',false)

            await firebase.database().ref('spark_set').orderByChild('name').equalTo(name).once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    const data = childSnapshot.val();
                    if(data!='')
                    {
                        if(user.company===data.companyId||data.companyId===undefined)
                        {
                            commit('setSparkStatus',true)
                        }
                    }    
                })
            })
               
            },
        async getSparkHappily({ commit, state,dispatch }: any,data:any) {
       
        const dataSparkSet:Array<any> = [];
        commit('setSparkHappilyloading', true);
        await firebase.database().ref('spark_set').once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    let cardList:Array<any> = [];
                    const _data = childSnapshot.val();

                    if(_data.companyId===undefined||_data.companyId===data.company)
                    {
                   
                    firebase.firestore().collection('spark_class').where("set", "==", childSnapshot.key).orderBy("order",'asc').get()
                    .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const data = doc.data();
                        cardList.push({...data,sparkTitle:data.name,id:doc.id})
                    })})
                    dataSparkSet.push({
                        ..._data,
                        cardList,
                        customSet: _data.customSet===undefined?0:_data.customSet,
                        id:childSnapshot.key,
                        happilySet:_data.order===undefined?_data.happilySet:_data.order,
                        type:_data.companyId===undefined?'happily':'custom',
                        permissions: normalizePermissions(_data.permissions),})
                    }
                })
            })
             // Program-only sets have no schedule position — keep them
             // out of the ordered "Happily's Sparks" list entirely.
             const scheduledList = dataSparkSet.filter((set) => !isProgramOnlySet(set.permissions));
             const sort_List = _.sortBy(scheduledList, ["happilySet", "customSet"]);
            commit('setSparkHappilyloading', false);
            //console.log('sort_List',sort_List)
            commit('setSparkHappily', sort_List)
           
        },
        async getSparkCustom({ commit, state }: any,data:any) {
            const dataSparkSetCustom:Array<any> = [];
           await firebase.database().ref('spark_set').orderByChild('companyId').equalTo(data.company).once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        const cardList:Array<any> = [];
                        const _data = childSnapshot.val(); 
                            firebase.firestore().collection('spark_class').where("set", "==", childSnapshot.key).orderBy("order",'asc').get()
                            .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                // console.log("data",data)
                                cardList.push({...data,sparkTitle:data.name,id:doc.id})
                            })})
                            dataSparkSetCustom.push({
                                ..._data,
                                cardList,
                                customSet: _data.customSet===undefined?0:_data.customSet,
                                id:childSnapshot.key,
                                happilySet:_data.order===undefined?_data.happilySet:_data.order,
                                type:_data.companyId===undefined?'happily':'custom',
                                permissions: normalizePermissions(_data.permissions),}) 
                        })
                    
                })
                //console.log('dataSparkSetCustom',dataSparkSetCustom)
                commit('setSparkCustom', dataSparkSetCustom)
               
            },
        async createSparkSetCustom({ commit, state }: any,data:any){

                firebase.database().ref("spark_set").push({...data,permissions:normalizePermissions(data.permissions)})
        },
        async updateSetNameSparkCustom({ commit, state,dispatch, rootState}: any,{data,user}:any){
            commit('setSparkStatus',false)
            await firebase.database().ref('spark_set').orderByChild('name').equalTo(data.name).once('value', (snapshot) => {
                snapshot.forEach((childSnapshot) => {
                    const data = childSnapshot.val();
                    if(data!='')
                    {
                        if(user.company===data.companyId||data.companyId===undefined)
                        {
                            commit('setSparkStatus',true)
                        }
                    }    
                })
            })
            if(!state.sparkStatus)
            {
                await firebase.database().ref(`spark_set/${data.id}`).update({name:data.name,permissions:normalizePermissions(data.permissions)});
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
                commit('setSparkStatus',false)
            }
           
        },
        async updatePositionsSparkCustom({ commit, state ,dispatch,rootState}: any,data:any){ 
            await firebase.database().ref(`spark_set/${data.id}`).update({customSet: data.customSet,happilySet: data.happilySet}).then(()=>{
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
            });

        },
        async updateSparkCustom({ commit, state,dispatch,rootState }: any,data:any){  
                await firebase.database().ref(`spark_set/${data.id}`).update({...data,permissions:normalizePermissions(data.permissions)}).then(()=>{
                /*save logs*/
                    dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        id: data.id,
                        table: 'spark_set',
                        status: 'update',
                        user: rootState.authen.user.email
                    }, {root:true})
                });

        },
        deleteSparkCustom({ commit, state,rootState,dispatch }: any,data:any){  
            firebase.database().ref(`spark_set/${data.id}`).remove().then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_set',
                    status: 'delete',
                    user: rootState.authen.user.email
                }, {root:true})
            })
            firebase.firestore().collection("spark_class").where('set', '==', data.id).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                  doc.ref.delete();
                });
                 /*save logs*/
                 dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_class',
                    status: 'delete',
                    user: rootState.authen.user.email
                }, {root:true})
              });
        },
        deleteSparkCustomClass({ commit, state ,rootState,dispatch}: any,data:any){  
             firebase.firestore().collection("spark_class").doc(data.id).delete().then(() => {
               /*save logs*/
               dispatch('authen/addLogs', {
                company: rootState.authen.user.company,
                createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                id: data.id,
                table: 'spark_class',
                status: 'delete',
                user: rootState.authen.user.email
            }, {root:true})
            })
        },
        async createSparkCustomClass({ commit, state }: any,data:any){  
           await firebase.firestore().collection("spark_class").add(data).then((docRef) => {
               
                commit('setCardId', docRef.id)
                
            })
        },
        updateSpartCustomClass({ commit, state ,dispatch,rootState}: any,{id,data}:any){  
            firebase.firestore().collection(`spark_class`).doc(id).update(data).then(()=>{
                /*save logs*/
                dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: data.id,
                    table: 'spark_class',
                    status: 'update',
                    user: rootState.authen.user.email
                }, {root:true})
            })
        },
        async getSparkType({ commit, state }: any) {
            const dataSparkType:Array<any> = [];
            const dataSparkTypeName= {};
            await firebase.database().ref('spark_type').once('value', (snapshot) => {
                    snapshot.forEach((childSnapshot) => {
                        const _data = childSnapshot.val();
                        
                        if(_data.image!==undefined)
                        {
                            dataSparkType.push({..._data,id:childSnapshot.key})
                            if(!dataSparkTypeName[_data.name])
                            {
                                dataSparkTypeName[_data.name]=_data
                                dataSparkTypeName[_data.name].id=childSnapshot.key
                            }
                        }
                    })
                })
                //console.log('dataSparkTypeName',dataSparkTypeName)
                commit('setSparkType', dataSparkType)
                commit('setSparkTypeName', dataSparkTypeName)
               
        },
        async genSparkSetAI({ commit, state,rootState,dispatch}: any,data:any){
           
            const dataSparkTypeName=state.dataSparkTypeName
            const materlanguage=(await firebase.database().ref(`/language`).once('value')).val()
            let userLanguage=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            userLanguage=_.groupBy(userLanguage,'language')
            let languages:Array<any>=[]
            const lang_code={}
            for(const i in userLanguage){

                if(materlanguage[i]){
                    languages.push(materlanguage[i].name)
                    lang_code[materlanguage[i].name]=materlanguage[i].code
                }
            }
            

            //console.log('languages',languages.toString())
            //languages=['English']
           const config:any = {
            method: 'post',
            url: '/openai/skill_set_ai',
            params: {
              skill: data.skill,
              lang: `[${languages.toString()}]`,
            },
          };
            const response = await apiNodeRequest(config)
            // const response = await axios.get(url)
           
            let newid :any =''
            const cardList:Array<any>=[]
            let cardRank={}
            //console.log('response',response.data)
            let newSet={}
            for(const lang in response.data){
                
                const raw = response.data[lang]
                const obj = typeof raw === 'string' ? JSON.parse(raw) : raw
                const jsonData = typeof obj === 'string' ? JSON.parse(obj) : obj

                //console.log('jsonData',jsonData)
                const langName=lang
                const langCode=lang//lang_code[langName]
               
            
                 
                if(langName=='en'){
                    newid=firebase.database().ref("spark_set").push().key
                    newSet={
                            name: jsonData.setName,
                            permissions: normalizePermissions(data.permissions),
                            happilySet: data.happilySet,
                            customSet:data.customSet+1,
                            companyId:rootState.authen.user.company,

                    }
                    const insert={}
                    insert[newid] = newSet;
                    //console.log('insert',insert)
                    firebase.database().ref('spark_set').update(insert);
                   
                }
                let count=0
                for(const card in jsonData.cards){
                    //content_[]
                    
                    if(!cardRank[count]){
                        cardRank[count]={}                  
                    }
                    cardRank[count][`content_${langCode}`]=jsonData.cards[card].body+'<br>'+jsonData.cards[card].nudge
                    if(langName=='en'){
                        cardList.push({
                            name:jsonData.cards[card].title,
                            order:Number(card)+1,
                            type:dataSparkTypeName[jsonData.cards[card].icon].id,
                            set:newid,
                            sparkTitle:jsonData.cards[card].title
                        })
                    }
                count++
                }

            }
            for(const card in cardList){
                if(cardRank[card]){
                    cardList[card]={...cardList[card],...cardRank[card],updated:format(new Date(), 'YYYY-MM-DD HH:mm:ss')}
                }
                const id_card=await firebase.firestore().collection("spark_class").add(cardList[card])
                cardList[card].id=id_card.id
            }   
            //console.log('cardList',cardList)
            
            return {cardList:cardList,id:newid,...newSet}
        }
    },
    getters: {
        sparkHappily:(state: any) => {
            return state.sparkHappily
        },
        sparkHappilyloading:(state: any) => {
            return state.sparkHappilyloading
        },
        sparkCustom:(state: any) => {
            return state.sparkCustom
        },
        sparkStatus(state: any, result: any) {
            return state.sparkStatus
        },
        cardId(state: any, result: any) {
            return state.cardId
        },
        customClass(state: any, result: any) {
            return state.customClass
        },
        sparkType:(state: any) => {
            return state.sparkType
        },
        permissionsList(state: any, result: any) {
            return state.permissionsList
        },

    }
}
